export default {
    //设置菜单列表
    setMenuList: "setMenuList",
    //设置菜单样式
    changeMenuTheme: "changeMenuTheme",
    //设置风格颜色
    changeMainTheme: "changeMainTheme",
    //设置首页
    setHomePage: "setHomePage",
    //打开页面
    openPage: "openPage",
    //打开页面
    closePage: "closePage",
    //关闭其他页面
    closeOtherPage: "closeOtherPage",
    //关闭所有打开页
    closeAllPage: "closeAllPage",
    //设置tab名称
    setTabTitle: "setTabTitle",
    //  socket
    setSocket: "setSocket",
    //设置语言
    switchLang: "switchLang"
};



//////////////////
// WEBPACK FOOTER
// ./src/store/mutationType.ts
// module id = null
// module chunks = 